module.exports = __webpack_public_path__ + "img/pip_three_icon6.2d8b7c10.png";